var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.firstTimeLoad)?_c('div',[_vm._t("default",null,{"settingsPool":_vm.settingsPool,"formData":_vm.formData,"save":_vm.save,"loading":_vm.loading,"isActive":_vm.isActive})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }